import { Paper, Typography } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import React from "react";
import { EventNotification } from "../../domain/EventNotification";
import { RegulatorsToNotify } from "../sections/RegulatorsToNotify";
import { EventDetails } from "../sections/EventDetails";
import { ExamSeries } from "../sections/ExamSeries";
import { Awareness } from "../sections/Awareness";
import { AffectedQualifications } from "../sections/AffectedQualifications";
import { AffectedCentres } from "../sections/AffectedCentres";
import { AffectedLearners } from "../sections/AffectedLearners";
import { NatureOfEvent } from "../sections/NatureOfEvent";
import { ActionsTaken } from "../sections/ActionsTaken";
import { SectionProps } from "../sections/SectionProps";
import { Compliance } from "../sections/Compliance";
import { AffectedExamDates } from "../sections/AffectedExamDates";
import { IncorrectResults } from "../sections/IncorrectResults";
import { MarksAffected } from "../sections/MarksAffected";

const useStyles = makeStyles((theme) => ({
  formSection: {
    padding: 30,
    boxShadow: "0 0 19px -2px hsla(0,0%,63.9%,.3)",
    border: "1px solid #ddd",
    backgroundColor: "#fff",
    borderRadius: "3px",
  },
}));

export const ItemDetails: React.FC<{
  sectionProps: SectionProps<EventNotification>;
}> = ({ sectionProps }) => {
  const classes = useStyles();

  return (
    <>
      <div>
        <form>
          <Typography variant="h6">Notify</Typography>
          <Paper className={classes.formSection}>
            <RegulatorsToNotify {...sectionProps} />
          </Paper>

          <Typography variant="h6">Main Details</Typography>
          <Paper className={classes.formSection}>
            <EventDetails {...sectionProps} />
          </Paper>

          <Typography variant="h6">Affected Exam Series</Typography>
          <Paper className={classes.formSection}>
            <ExamSeries {...sectionProps} />
          </Paper>

          <Typography variant="h6">Affected assessment dates</Typography>
          <Paper className={classes.formSection}>
            <AffectedExamDates {...sectionProps} />
          </Paper>
          
          <Typography variant="h6">Awareness</Typography>
          <Paper className={classes.formSection}>
            <Awareness {...sectionProps} />
          </Paper>

          <Typography variant="h6">Affected - Qualifications and units</Typography>
          <Paper className={classes.formSection}>
            <AffectedQualifications {...sectionProps} />
          </Paper>

          <Typography variant="h6">Affected - Centres</Typography>
          <Paper className={classes.formSection}>
            <AffectedCentres {...sectionProps} />
          </Paper>

          <Typography variant="h6">Affected - Learners</Typography>
          <Paper className={classes.formSection}>
            <AffectedLearners {...sectionProps} />
          </Paper>

          <Typography variant="h6">Nature of Event</Typography>
          <Paper className={classes.formSection}>
            <NatureOfEvent {...sectionProps} />
          </Paper>

          <Typography variant="h6">No. of Marks</Typography>
          <Paper className={classes.formSection}>
            <MarksAffected {...sectionProps} />
          </Paper>

          <Typography variant="h6">Incorrect Results</Typography>
          <Paper className={classes.formSection}>
            <IncorrectResults {...sectionProps} />
          </Paper>

          <Typography variant="h6">Actions Taken</Typography>
          <Paper className={classes.formSection}>
            <ActionsTaken {...sectionProps} />
          </Paper>

          <Typography variant="h6">Compliance</Typography>
          <Paper className={classes.formSection}>
            <Compliance {...sectionProps} />
          </Paper>
        </form>
      </div>
    </>
  );
};
